module.exports = __webpack_public_path__ + "img/leaf_5.3920828b.png";